// src/router/index.js
import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/url_router',
    name: 'urlRouter',
    component: () => import('../page/urlRouter.vue'),
    meta: { noScroll: true }
  },
  {
    path: '/familytree',
    name: 'FamilyTree',
    component: () => import('../page/FamilyTree.vue'),
    meta: { keepAlive: true } // 只有这里设为 true
  },

   {
    path: '/familytree_admin',
    name: 'FamilyTreeAdmin',
    component: () => import('../page/FamilyTree_admin.vue'),
    meta: { keepAlive: true } // 只有这里设为 true
  },
  
  {
    path: '/add_family_member',
    name: 'AddFamilyMember',
    component: () => import('../page/add_family_member.vue'),
    meta: { noScroll: true }
  },

  {
    path: '/edit_member/:id',
    name: 'EditMember',
    component: () => import('../page/edit_member.vue')
  },

  {
    path: '/map-tracking',
    name: 'MapTracking',
    component: () => import('../page/map_tracking.vue')
  },

   {
    path: '/add_batch_members/:id/:parent_name',
    name: 'AddBatchMember',
    component: () => import('../page/add_batch_members.vue'),
    meta: { noScroll: true }
  },

  {
    path: '/MemberDetail/:id',
    name: 'MemberDetail',
    component: () => import('../page/MemberDetail.vue'),
    meta: { keepAlive: false }
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.noScroll) {
    document.body.classList.add("body-no-scroll")
  } else {
    document.body.classList.remove("body-no-scroll")
  }
  next()
})

// 🚀 根路径跳转到 familytree
if (window.location.pathname === '/' || window.location.pathname === '') {
    window.location.hash = '#/familytree';
}

export default router